/**
 * Shared, spring-smoothed Hero speed multiplier.
 * Both tracks read it every frame; integration is time-stamped so it
 * advances exactly once per frame no matter how many tracks call it.
 */
export interface HeroSpeed {
  value: number;
  velocity: number;
  target: number;
  lastT: number;
}

export const HERO_HOVER_SPEED = 0.16;
const STIFFNESS = 120;
const DAMPING = 22; // ≈ critical → smooth decel, no overshoot

export function createHeroSpeed(): HeroSpeed {
  return { value: 1, velocity: 0, target: 1, lastT: 0 };
}

export function stepHeroSpeed(s: HeroSpeed, now: number): number {
  if (s.lastT === 0) { s.lastT = now; return s.value; }
  if (now <= s.lastT) return s.value;
  let dt = Math.min((now - s.lastT) / 1000, 0.1);
  s.lastT = now;
  while (dt > 0) {
    const h = Math.min(dt, 1 / 120);
    const accel = STIFFNESS * (s.target - s.value) - DAMPING * s.velocity;
    s.velocity += accel * h;
    s.value += s.velocity * h;
    dt -= h;
  }
  if (s.value < 0.05) { s.value = 0.05; s.velocity = 0; } // never fully stop
  return s.value;
}